import React from 'react';
import {useViewport, withinOrWiderThan} from '@udemy-v2/react-layout-components';
import {SocialProofDesktop} from './desktop/social-proof-desktop.react-component';
import {SocialProofMobile} from './mobile/social-proof-mobile.react-component';

export const SocialProof: React.FC = () => {
    const {range} = useViewport();
    const isDesktopViewport = range && withinOrWiderThan(range, 'lg');

    // For desktop (lg and above), use desktop component with parallax
    if (isDesktopViewport) {
        return <SocialProofDesktop />;
    }

    // For mobile and tablets (below lg), use mobile component without parallax
    return <SocialProofMobile />;
};
